/*
  Shared reveal for the About page sections.

  One IntersectionObserver for every .wv-animate element on the page.
  Each section emits a tag for this file, so it is fetched once and
  cached; the window guard makes every execution after the first a
  no-op. That is cheaper than inlining the same observer six times.
*/
  (function () {
if (window.__wvAboutReveal) return;
window.__wvAboutReveal = true;

function start() {
  var targets = document.querySelectorAll('.wv-animate');
  if (!targets.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    for (var i = 0; i < targets.length; i++) targets[i].classList.add('wv-animate--visible');
    return;
  }

  /* Stagger within a section, capped so a long section never
     holds its last element back by an absurd amount. */
  var seen = {};
  for (var j = 0; j < targets.length; j++) {
    var el = targets[j];
    var sec = el.closest('[id^="shopify-section-"]');
    var key = sec ? sec.id : '_';
    seen[key] = (seen[key] || 0) + 1;
    el.style.transitionDelay = Math.min((seen[key] - 1) * 80, 320) + 'ms';
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('wv-animate--visible');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  for (var k = 0; k < targets.length; k++) io.observe(targets[k]);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
  })();
